import React from "react";

const Emailer = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://suppressionagent.livauto.com/emailer.php"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="Emailer"
      ></iframe>
    </div>
  );
};

export default Emailer;
